var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { MARK_RTO_RECEIVED_REQUEST, markRtoReceivedFailure, markRtoReceivedSuccess } from "../../actions";
import APIIN from "../../../utils/APIIN";
const markRtoReceivedDetails = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const data = action.payload;
        try {
            APIIN.put("/cnvt/shipment/tags", data)
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            if (error instanceof Error) {
                reject(error);
            }
        }
    }));
});
function* markRtoReceivedDataWorker(action) {
    try {
        const data = yield call(markRtoReceivedDetails, action);
        yield put(markRtoReceivedSuccess(data));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.messages) {
            yield put(markRtoReceivedFailure(error.response.data.messages));
        }
        else {
            yield put(markRtoReceivedFailure(error));
        }
    }
}
export function* watchMarkRtoReceivedData() {
    yield takeLatest(MARK_RTO_RECEIVED_REQUEST, markRtoReceivedDataWorker);
}
